import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Drawer from 'presentations/views/components/atoms/Drawer';
import {
  fontWeight,
  fontSize,
  spacing,
  mediaMax,
} from 'presentations/views/styles';
import { black, gray05 } from 'presentations/views/styles/color';

interface Props {
  menuList: any[];
  isOpen: boolean;
  onClose?: any;
  header?: ReactNode;
  footer?: ReactNode;
  direction?: 'top' | 'right' | 'left';
  className?: string;
}

export default function Component(props: Props) {
  return (
    <Drawer
      anchor={props.direction || 'right'}
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <Container className={props.className}>
        {props.header}
        <MenuContainer>
          {props.menuList.map((menu) => (
            <>
              {menu.label === '-' ? (
                <MenuDivider />
              ) : (
                <Item
                  key={menu.label}
                  href={menu.link}
                  target={menu.target}
                  onClick={menu.onClick}
                >
                  {menu.icon}
                  <ItemName>
                    <ItemLink>{menu.label}</ItemLink>
                  </ItemName>
                </Item>
              )}
            </>
          ))}
        </MenuContainer>
        {props.footer}
      </Container>
    </Drawer>
  );
}

const Container = styled.div`
  min-width: 240px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const MenuContainer = styled.div`
  flex: 1;
`;
const Item = styled.a`
  display: flex;
  align-items: center;
  font-size: ${fontSize(13)};
  margin: 0 ${spacing(16)} ${spacing(16)};
`;
const ItemName = styled.div`
  margin-left: ${spacing(12)};
  font-weight: ${fontWeight('bold')};
`;
const ItemLink = styled.span`
  color: ${black};
`;

const MenuDivider = styled.div`
  background-color: ${gray05};
  height: 1px;
  margin: 0 ${spacing(16)} ${spacing(16)};
  width: 100%;
`;
